import { IDonorRegistration } from "@nkr/models/donor-registration";
import { OrganType } from '@nkr/enums/index';
import { Badge, Col, Row } from "react-bootstrap";
import { cardBodyStyle, cardBodyTitleStyle, cardStyle, cardBodyTitleTextStyle } from "../../styles";

interface IProps {
    data: IDonorRegistration,
}

const RegistrationInfo = ({data}:IProps) => {
    return (
        <div id='registration-info' style={cardStyle}>
            <div style={cardBodyStyle}>
                <div style={cardBodyTitleStyle}>
                    <span style={cardBodyTitleTextStyle}>Registration Information</span>
                </div>
                <Row>
                    {data.voucherEducationChoice !== null && (
                        <>
                            <Col xs={6} sm={2}><strong>Voucher:</strong></Col>
                            <Col xs={6} sm={4}>
                                {data.voucherEducationChoice}
                            </Col>
                        </>
                    )}

                    <Col xs={6} sm={2}><strong>Registered as:</strong></Col>
                    <Col xs={6} sm={4}>
                        {data.isAdp ?
                            <Badge style={{ backgroundColor: '#3DAD5C', color: '#FFF' }}>{data.donorSituation}</Badge>
                            :
                            <>{data.donorSituation}</>
                        }
                    </Col>
                </Row>

                <Row>
                    <Col xs={6} sm={2}><strong>Source:</strong></Col>
                    <Col xs={6} sm={4}>{data.source}</Col>

                    <Col xs={6} sm={2}><strong>E-mail:</strong></Col>
                    <Col xs={6} sm={4}><a href={`mailto:${data.email}`}>{data.email}</a></Col>
                </Row>

                <Row>
                    <Col xs={6} sm={2}><strong>Organ:</strong></Col>
                    <Col xs={6} sm={4}>{OrganType[data.donationType]}</Col>
                </Row>
            </div>
        </div>
    );
}

export default RegistrationInfo;